export default __webpack_public_path__ + "static/media/google-store.b5d09fe7.svg";